<div class="flex flex-col p-6" *ngIf="vm$ | async as vm">
	<div class="flex justify-center">
		<img
			class="w-1/5"
			src="/assets/images/leap/matter-lawyer-clerk-mapping.png"
			alt="Matter lawyer or clerk alert"
		/>
	</div>
	<div class="flex justify-center mt-8">
		<h1 class="text-3xl font-medium">
			Unable to Add LEAP
			<span *ngIf="vm.displayMode === DisplayMode.LAWYER_ONLY">Lawyer</span>
			<span *ngIf="vm.displayMode === DisplayMode.CLERK_ONLY">Clerk</span>
			<span *ngIf="vm.displayMode === DisplayMode.BOTH">Lawyer And Clerk</span>
			to Closer Matter
		</h1>
	</div>
	<div class="flex justify-center gap-4">
		<ui-section
			*ngIf="
				vm.displayMode === DisplayMode.LAWYER_ONLY ||
				vm.displayMode === DisplayMode.BOTH
			"
			class="h-full w-2/5"
			title="Lawyer"
			type="section"
		>
			<div
				section-content
				class="grid grid-rows-fit-content grid-cols-[1fr_4fr] gap-x-5"
			>
				<div class="text-sm font-medium">LEAP</div>
				<div class="text-sm">{{ vm.leapLawyerName }}</div>
			</div>
		</ui-section>

		<ui-section
			*ngIf="
				vm.displayMode === DisplayMode.CLERK_ONLY ||
				vm.displayMode === DisplayMode.BOTH
			"
			class="h-full w-2/5"
			title="Clerk"
			type="section"
		>
			<div
				section-content
				class="grid grid-rows-fit-content grid-cols-[1fr_4fr] gap-x-5"
			>
				<div class="text-sm font-medium">LEAP</div>
				<div class="text-sm">{{ vm.leapClerkName }}</div>
			</div>
		</ui-section>
	</div>
	<div class="flex justify-center mt-4">
		<span *ngIf="vm.displayMode === DisplayMode.LAWYER_ONLY"
			>This lawyer has not yet connected to Closer within LEAP. Please contact
			an admin to onboard this user.</span
		>
		<span *ngIf="vm.displayMode === DisplayMode.CLERK_ONLY"
			>This clerk has not yet connected to Closer within LEAP. Please contact an
			admin to onboard this user.</span
		>
		<span *ngIf="vm.displayMode === DisplayMode.BOTH"
			>This lawyer and clerk has not yet connected to Closer within LEAP. Please
			contact an admin to onboard these users.</span
		>
	</div>
	<div class="flex justify-center mt-8">
		<ui-button
			preset="HIGH_EMPHASIS"
			label="Continue"
			(click)="closeDialog()"
		></ui-button>
	</div>
</div>
